import { copy } from '@/content/copy';
import { env } from '@/lib/env';

function safeHttps(value: string) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' ? url.href : '';
  } catch {
    return '';
  }
}

export function StoreFooter() {
  const site = safeHttps(env?.VITE_OFFICIAL_SITE ?? '');
  const email = env?.VITE_SUPPORT_EMAIL ?? '';
  const hasLinks = Boolean(site || email);

  return (
    <footer className="border-t border-brand-line bg-night px-7 pt-12 pb-10 text-center text-[0.85rem] text-brand-muted max-[560px]:px-[18px] max-[560px]:pt-[38px] max-[560px]:pb-8">
      {hasLinks && (
        <nav aria-label="Store links" className="mb-3.5 flex flex-wrap justify-center gap-x-6 gap-y-2">
          {site && (
            <a
              href={site}
              rel="noopener noreferrer"
              target="_blank"
              className="text-cream underline decoration-brand-line underline-offset-4 transition-colors hover:text-gold-soft"
            >
              {copy.footer.officialSite}
            </a>
          )}
          {email && (
            <a
              href={`mailto:${email}`}
              className="text-cream underline decoration-brand-line underline-offset-4 transition-colors hover:text-gold-soft"
            >
              {copy.footer.support}
            </a>
          )}
        </nav>
      )}
      <p>{copy.footer.rights}</p>
    </footer>
  );
}
